// extracted by mini-css-extract-plugin
export default {"wrap":"DG-z","articleImagesWrap":"EG-z","articleImage":"FG-z","singleImage":"GG-z"};